import { bootHeader } from './header/entrypoint';

bootHeader();
